import React from 'react';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Bono #1 – Cuando el día no fue perfecto',
    desc: 'Reconectar incluso en días difíciles',
    img: 'https://cdn.magicpatterns.com/uploads/6jeBGYcdwsfC6jKZ3LL5zW/mockup_bono1.png'
  }, {
    title: 'Bono #2 – Te escucho de verdad',
    desc: 'Escuchar sin corregir, conectar sin juzgar',
    img: 'https://cdn.magicpatterns.com/uploads/nmxCwvDfY5HYpjD1Nw3zpH/mockup_bono_2.png'
  }, {
    title: 'Bono #3 – Pequeñas tradiciones, grandes recuerdos',
    desc: 'Rituales familiares que crean identidad',
    img: 'https://cdn.magicpatterns.com/uploads/8muVZV88LN9CFjmWLDZ8Fe/mockuop_bono_3.png'
  }];
  return <section className="py-8 px-4 bg-gray-900 text-white" data-id="element-48">
      <div className="max-w-4xl mx-auto" data-id="element-49">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2 text-yellow-400" data-id="element-50">
          🎁 BONOS EXCLUSIVOS – SOLO HOY
        </h2>
        <p className="text-center text-gray-300 mb-6" data-id="element-51">
          Llevate estos 3 regalos adicionales totalmente GRATIS
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-52">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-gray-800 rounded-xl overflow-hidden shadow-2xl border border-gray-700 flex flex-col" data-id="element-53">
              <div className="relative" data-id="element-54">
                <a href="#compra" data-id="element-55">
                  <img src={bonus.img} alt={bonus.title} className="w-full aspect-square object-cover hover:opacity-90 transition-opacity" data-id="element-56" />
                </a>
                <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-57">
                  GRATIS
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col" data-id="element-58">
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-59">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-60">{bonus.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}